/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClearDocumentHistoryCommand } from '../models/ClearDocumentHistoryCommand';
import type { ClearDocumentHistoryCommandResult } from '../models/ClearDocumentHistoryCommandResult';
import type { ConfirmEmailChangeCommand } from '../models/ConfirmEmailChangeCommand';
import type { CreateDocumentCommand } from '../models/CreateDocumentCommand';
import type { CreateDocumentCommandResult } from '../models/CreateDocumentCommandResult';
import type { CreateDocumentCommentCommand } from '../models/CreateDocumentCommentCommand';
import type { CreateFolderCommand } from '../models/CreateFolderCommand';
import type { CreateFolderCommandResult } from '../models/CreateFolderCommandResult';
import type { CreatePersonalAccessTokenCommand } from '../models/CreatePersonalAccessTokenCommand';
import type { CreatePersonalAccessTokenCommandResult } from '../models/CreatePersonalAccessTokenCommandResult';
import type { CreateProjectCommand } from '../models/CreateProjectCommand';
import type { CreateProjectCommandResult } from '../models/CreateProjectCommandResult';
import type { CreateRoleCommand } from '../models/CreateRoleCommand';
import type { CreateRoleCommandResult } from '../models/CreateRoleCommandResult';
import type { CreateUserCommand } from '../models/CreateUserCommand';
import type { CreateUserCommandResult } from '../models/CreateUserCommandResult';
import type { DeleteDocumentCommand } from '../models/DeleteDocumentCommand';
import type { DeleteDocumentCommentCommand } from '../models/DeleteDocumentCommentCommand';
import type { DeleteFolderCommand } from '../models/DeleteFolderCommand';
import type { DocumentCommentResponse } from '../models/DocumentCommentResponse';
import type { EditDocumentCommentCommand } from '../models/EditDocumentCommentCommand';
import type { EditUserCommand } from '../models/EditUserCommand';
import type { ForceSendUserVerificationEmailCommand } from '../models/ForceSendUserVerificationEmailCommand';
import type { GetCurrentUserProfileQueryResponse } from '../models/GetCurrentUserProfileQueryResponse';
import type { GetDocumentQueryResponse } from '../models/GetDocumentQueryResponse';
import type { GetGlobalSettingsQueryResponse } from '../models/GetGlobalSettingsQueryResponse';
import type { LoginCommand } from '../models/LoginCommand';
import type { LoginCommandResult } from '../models/LoginCommandResult';
import type { MarkDocumentCommentsReadCommand } from '../models/MarkDocumentCommentsReadCommand';
import type { MoveDocumentCommand } from '../models/MoveDocumentCommand';
import type { MoveFolderCommand } from '../models/MoveFolderCommand';
import type { RecreateDbCommand } from '../models/RecreateDbCommand';
import type { RegisterUserCommand } from '../models/RegisterUserCommand';
import type { RegisterUserCommandResult } from '../models/RegisterUserCommandResult';
import type { RenameDocumentCommand } from '../models/RenameDocumentCommand';
import type { RenameFolderCommand } from '../models/RenameFolderCommand';
import type { RequestEmailChangeCommand } from '../models/RequestEmailChangeCommand';
import type { RequestPasswordResetCommand } from '../models/RequestPasswordResetCommand';
import type { ResetPasswordCommand } from '../models/ResetPasswordCommand';
import type { RestoreDocumentHistoryCommand } from '../models/RestoreDocumentHistoryCommand';
import type { RevokePersonalAccessTokenCommand } from '../models/RevokePersonalAccessTokenCommand';
import type { RoleSummary } from '../models/RoleSummary';
import type { SaveDocumentCommand } from '../models/SaveDocumentCommand';
import type { SaveDocumentCommandResult } from '../models/SaveDocumentCommandResult';
import type { SetProjectAccessRulesCommand } from '../models/SetProjectAccessRulesCommand';
import type { SetUserGlobalRoleCommand } from '../models/SetUserGlobalRoleCommand';
import type { SetUserProjectRoleCommand } from '../models/SetUserProjectRoleCommand';
import type { UpdateCurrentUserProfileCommand } from '../models/UpdateCurrentUserProfileCommand';
import type { UpdateGlobalSettingsCommand } from '../models/UpdateGlobalSettingsCommand';
import type { UpdateRolePermissionsCommand } from '../models/UpdateRolePermissionsCommand';
import type { UpdateUserAdministrationCommand } from '../models/UpdateUserAdministrationCommand';
import type { VacuumDatabaseCommand } from '../models/VacuumDatabaseCommand';
import type { VacuumDatabaseCommandResult } from '../models/VacuumDatabaseCommandResult';
import type { VerifyEmailCommand } from '../models/VerifyEmailCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CommandsService {
    /**
     * @returns LoginCommandResult OK
     * @throws ApiError
     */
    public static commandLoginCommand({
        requestBody,
    }: {
        requestBody: LoginCommand,
    }): CancelablePromise<LoginCommandResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/LoginCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns RegisterUserCommandResult OK
     * @throws ApiError
     */
    public static commandRegisterUserCommand({
        requestBody,
    }: {
        requestBody: RegisterUserCommand,
    }): CancelablePromise<RegisterUserCommandResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/RegisterUserCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static commandVerifyEmailCommand({
        requestBody,
    }: {
        requestBody: VerifyEmailCommand,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/VerifyEmailCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static commandRequestPasswordResetCommand({
        requestBody,
    }: {
        requestBody: RequestPasswordResetCommand,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/RequestPasswordResetCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static commandResetPasswordCommand({
        requestBody,
    }: {
        requestBody: ResetPasswordCommand,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/ResetPasswordCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static commandConfirmEmailChangeCommand({
        requestBody,
    }: {
        requestBody: ConfirmEmailChangeCommand,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/ConfirmEmailChangeCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static commandRequestEmailChangeCommand({
        requestBody,
    }: {
        requestBody: RequestEmailChangeCommand,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/RequestEmailChangeCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns GetCurrentUserProfileQueryResponse OK
     * @throws ApiError
     */
    public static commandUpdateCurrentUserProfileCommand({
        requestBody,
    }: {
        requestBody: UpdateCurrentUserProfileCommand,
    }): CancelablePromise<GetCurrentUserProfileQueryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/UpdateCurrentUserProfileCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns CreatePersonalAccessTokenCommandResult OK
     * @throws ApiError
     */
    public static commandCreatePersonalAccessTokenCommand({
        requestBody,
    }: {
        requestBody: CreatePersonalAccessTokenCommand,
    }): CancelablePromise<CreatePersonalAccessTokenCommandResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/CreatePersonalAccessTokenCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static commandRevokePersonalAccessTokenCommand({
        requestBody,
    }: {
        requestBody: RevokePersonalAccessTokenCommand,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/RevokePersonalAccessTokenCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns SaveDocumentCommandResult OK
     * @throws ApiError
     */
    public static commandSaveDocumentCommand({
        requestBody,
    }: {
        requestBody: SaveDocumentCommand,
    }): CancelablePromise<SaveDocumentCommandResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/SaveDocumentCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns DocumentCommentResponse OK
     * @throws ApiError
     */
    public static commandCreateDocumentCommentCommand({
        requestBody,
    }: {
        requestBody: CreateDocumentCommentCommand,
    }): CancelablePromise<DocumentCommentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/CreateDocumentCommentCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static commandEditDocumentCommentCommand({
        requestBody,
    }: {
        requestBody: EditDocumentCommentCommand,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/EditDocumentCommentCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static commandDeleteDocumentCommentCommand({
        requestBody,
    }: {
        requestBody: DeleteDocumentCommentCommand,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/DeleteDocumentCommentCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static commandMarkDocumentCommentsReadCommand({
        requestBody,
    }: {
        requestBody: MarkDocumentCommentsReadCommand,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/MarkDocumentCommentsReadCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns GetDocumentQueryResponse OK
     * @throws ApiError
     */
    public static commandRestoreDocumentHistoryCommand({
        requestBody,
    }: {
        requestBody: RestoreDocumentHistoryCommand,
    }): CancelablePromise<GetDocumentQueryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/RestoreDocumentHistoryCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns CreateFolderCommandResult OK
     * @throws ApiError
     */
    public static commandCreateFolderCommand({
        requestBody,
    }: {
        requestBody: CreateFolderCommand,
    }): CancelablePromise<CreateFolderCommandResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/CreateFolderCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns CreateDocumentCommandResult OK
     * @throws ApiError
     */
    public static commandCreateDocumentCommand({
        requestBody,
    }: {
        requestBody: CreateDocumentCommand,
    }): CancelablePromise<CreateDocumentCommandResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/CreateDocumentCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static commandRenameFolderCommand({
        requestBody,
    }: {
        requestBody: RenameFolderCommand,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/RenameFolderCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static commandRenameDocumentCommand({
        requestBody,
    }: {
        requestBody: RenameDocumentCommand,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/RenameDocumentCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static commandMoveFolderCommand({
        requestBody,
    }: {
        requestBody: MoveFolderCommand,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/MoveFolderCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static commandMoveDocumentCommand({
        requestBody,
    }: {
        requestBody: MoveDocumentCommand,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/MoveDocumentCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static commandDeleteFolderCommand({
        requestBody,
    }: {
        requestBody: DeleteFolderCommand,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/DeleteFolderCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static commandDeleteDocumentCommand({
        requestBody,
    }: {
        requestBody: DeleteDocumentCommand,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/DeleteDocumentCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns CreateUserCommandResult OK
     * @throws ApiError
     */
    public static commandCreateUserCommand({
        requestBody,
    }: {
        requestBody: CreateUserCommand,
    }): CancelablePromise<CreateUserCommandResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/CreateUserCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static commandEditUserCommand({
        requestBody,
    }: {
        requestBody: EditUserCommand,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/EditUserCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static commandForceSendUserVerificationEmailCommand({
        requestBody,
    }: {
        requestBody: ForceSendUserVerificationEmailCommand,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/ForceSendUserVerificationEmailCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns CreateProjectCommandResult OK
     * @throws ApiError
     */
    public static commandCreateProjectCommand({
        requestBody,
    }: {
        requestBody: CreateProjectCommand,
    }): CancelablePromise<CreateProjectCommandResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/CreateProjectCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns CreateRoleCommandResult OK
     * @throws ApiError
     */
    public static commandCreateRoleCommand({
        requestBody,
    }: {
        requestBody: CreateRoleCommand,
    }): CancelablePromise<CreateRoleCommandResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/CreateRoleCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns RoleSummary OK
     * @throws ApiError
     */
    public static commandUpdateRolePermissionsCommand({
        requestBody,
    }: {
        requestBody: UpdateRolePermissionsCommand,
    }): CancelablePromise<RoleSummary> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/UpdateRolePermissionsCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static commandSetUserGlobalRoleCommand({
        requestBody,
    }: {
        requestBody: SetUserGlobalRoleCommand,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/SetUserGlobalRoleCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static commandSetUserProjectRoleCommand({
        requestBody,
    }: {
        requestBody: SetUserProjectRoleCommand,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/SetUserProjectRoleCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static commandSetProjectAccessRulesCommand({
        requestBody,
    }: {
        requestBody: SetProjectAccessRulesCommand,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/SetProjectAccessRulesCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns GetGlobalSettingsQueryResponse OK
     * @throws ApiError
     */
    public static commandUpdateGlobalSettingsCommand({
        requestBody,
    }: {
        requestBody: UpdateGlobalSettingsCommand,
    }): CancelablePromise<GetGlobalSettingsQueryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/UpdateGlobalSettingsCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static commandUpdateUserAdministrationCommand({
        requestBody,
    }: {
        requestBody: UpdateUserAdministrationCommand,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/UpdateUserAdministrationCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns ClearDocumentHistoryCommandResult OK
     * @throws ApiError
     */
    public static commandClearDocumentHistoryCommand({
        requestBody,
    }: {
        requestBody: ClearDocumentHistoryCommand,
    }): CancelablePromise<ClearDocumentHistoryCommandResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/ClearDocumentHistoryCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns VacuumDatabaseCommandResult OK
     * @throws ApiError
     */
    public static commandVacuumDatabaseCommand({
        requestBody,
    }: {
        requestBody: VacuumDatabaseCommand,
    }): CancelablePromise<VacuumDatabaseCommandResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/VacuumDatabaseCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static commandRecreateDbCommand({
        requestBody,
    }: {
        requestBody: RecreateDbCommand,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/commands/RecreateDbCommand',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
}
